const createDefaultConfigurationItem = () => ({
  name: 'fake',
  version: 1,
});

export const DEFAULT_DEVICE_CONFIGURATION = {
  // Legacy field for Vue-side compatibility in old code paths.
  device: 'ALLTESTA',
  // React frontendV2 expects this field when computing capabilities.
  deviceType: 'ALLTESTA',
  pump: [createDefaultConfigurationItem(), createDefaultConfigurationItem()],
  autosampler: [createDefaultConfigurationItem()],
  valve: [createDefaultConfigurationItem()],
  detector: [createDefaultConfigurationItem()],
};

export const DEVICE_CONFIGURATION_FOR_IMPORT = {
  ...DEFAULT_DEVICE_CONFIGURATION,
  isForImport: true,
};
